import AppHeader from "../../layout/AppHeader";
import Unit from '../../xpost/views/register/unit/Unit.vue';

const UnitRoutes = [
    {
        path: "/cadastro/unidade",
        name: "unit",
        components: {
            header: AppHeader,
            default: Unit
        }
    }
]

export default UnitRoutes;